/**
 * 自定义指令
 * @param {App<Element>} app vue创建的app实例
 */
export default function (app) {
    // app.directive("", {
    //     // 在绑定元素的 attribute 前
    //     // 或事件监听器应用前调用
    //     created(el, binding, vnode, prevVnode) {
    //         // 下面会介绍各个参数的细节
    //     },
    //     // 在元素被插入到 DOM 前调用
    //     beforeMount(el, binding, vnode, prevVnode) { },
    //     // 在绑定元素的父组件
    //     // 及他自己的所有子节点都挂载完成后调用
    //     mounted(el, binding, vnode, prevVnode) { },
    //     // 绑定元素的父组件更新前调用
    //     beforeUpdate(el, binding, vnode, prevVnode) { },
    //     // 在绑定元素的父组件
    //     // 及他自己的所有子节点都更新后调用
    //     updated(el, binding, vnode, prevVnode) { },
    //     // 绑定元素的父组件卸载前调用
    //     beforeUnmount(el, binding, vnode, prevVnode) { },
    //     // 绑定元素的父组件卸载后调用
    //     unmounted(el, binding, vnode, prevVnode) { }
    // });
    /**
     * 读医保卡
     * @param {Object} binding.value.bind 绑定对象
     * @param {String} binding.value.key 绑定值字段, 默认healthInsuranceCard
     * @param {String} binding.value.patiId 绑定值字段, 默认id
     * @param {String} binding.value.name 姓名字段，默认patiname
     * @param {String} binding.value.sex 性别字段，默认sexid
     * @param {String} binding.value.birth 出生日期字段，默认birthdatetime
     * @param {String} binding.value.cardId 证件号码字段，默认idCardNo
     * @param {String} binding.value.idType 证件类型字段，默认idTypeId
     * @param {String} binding.value.tel 证件类型字段，默认tel
     * 
     * @param {Function} binding.value.handle 接口结束后调用，返回接口数据
     */
    app.directive("readMedCard", {
        async beforeMount(el, binding, _vnode, _prevVnode) {
            const bindValue = binding.value;
            const {
                bind: dataObject,
                handle: triggerFun = () => { },
                key = "healthInsuranceCard",
                patiId = "id",
                name = "patiname",
                sex = "sexid",
                birth = "birthdatetime",
                cardId = "idCardNo",
                idType = 'idTypeId',
                tel = 'tel'
            } = bindValue;

            const { isObject, isFunction } = await import("lodash");
            // 指令报错提示
            const tipLog = (msg) => new Error('[v-readMedCard]: ' + msg);
            if (el.nodeName !== 'button'.toLocaleUpperCase()) {
                throw tipLog("仅用于arco<button>");
            }
            if (!isObject(bindValue)) {
                throw tipLog("仅支持绑定Object类型");
            }
            if (!dataObject) {
                throw tipLog("bind is required.");
            }
            if (!isObject(dataObject)) {
                throw tipLog("bind 仅支持绑定Object类型");
            }
            el.addEventListener("click", async () => {
                // 创建span元素，放loading组件
                const span = document.createElement("span");
                span.innerHTML = `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" class="arco-icon arco-icon-loading arco-icon-spin" stroke-width="4" stroke-linecap="butt" stroke-linejoin="miter"><path d="M42 24c0 9.941-8.059 18-18 18S6 33.941 6 24 14.059 6 24 6"></path></svg>`
                span.className = "arco-btn-icon";
                // 延迟50ms，把loading元素添加到按钮内部最前面
                const timeout = setTimeout(() => {
                    // 设置为禁用
                    el.disabled = true;
                    // 给btn添加loading类
                    el.classList.add("arco-btn-loading");
                    el.insertBefore(span, el.firstChild);
                    clearTimeout(timeout);
                }, 50);

                // 指令结束
                function close() {
                    clearTimeout(timeout);
                    // 关闭禁用
                    el.disabled = false;
                    // 去除loading类
                    el.classList.remove("arco-btn-loading");
                    // 删除添加的span元素
                    el.children.length && el.removeChild(span);
                }

                /**
                 * 调用医保读卡接口
                 */
                try {
                    const { getPersonInfo } = await import("@/api/client.js");
                    const { data } = await getPersonInfo();
                    const obj = {
                        [key]: data.socialSecurityCardNum, // 医保卡号
                        [patiId]: data.patiId,// 患者ID
                        [name]: data.patiName, // 患者姓名
                        [sex]: ['0', '9'].includes(data.patientGender) ? 3 : (Number(data.patientGender) ?? null), // 患者性别
                        [birth]: data.birthDate, // 出生日期
                        [cardId]: data.idCardNo, // 身份证号
                        ...(data.idCardNo ? { [idType]: 1 } : {}), // 如果有身份证号，把证件类型改为身份证
                        [tel]: data.tel, // 手机号码
                    }
                    Object.assign(dataObject, obj);
                    // 如果传入handle方法，调用方法
                    if (triggerFun && isFunction(triggerFun)) triggerFun(data);
                    close();
                } catch (error) {
                    if (error?.statusCode === 'ERR_NETWORK') {
                        const clientRender = await import("@/components/tipsCom/clientRender.js")
                        clientRender.default.show();
                    }
                    close();
                }
            })
        }
    })
}